import React from "react"
import { Card, CardBody, CardTitle, Button, Row, Col } from "reactstrap"
import { useTranslation } from "react-i18next"
import NoDataAvailable from "components/Shared/NoDataAvailable"

const ContractDetails = ({ data, onAccept, onReject }) => {
  const { t } = useTranslation()

  if (!data) {
    return (
      <Card>
        <CardBody>
          <CardTitle tag="h5">{t("Contract Details")}</CardTitle>

          <NoDataAvailable />
        </CardBody>
      </Card>
    )
  }

  return (
    <Card className="mb-4">
      <CardBody>
        <CardTitle tag="h5">{t("Contract Details")}</CardTitle>
        <Row>
          <Col md={3} xs={12} className="mb-1">
            <p>
              <a
                href={data.contract_file_path}
                target="_blank"
                rel="noopener noreferrer"
              >
                {data.contract_file_name}
              </a>
            </p>
          </Col>
          <Col md={3} xs={12} className="mb-1">
            <p>
              <strong>{t("Signed At")}:</strong>{" "}
              {data.signed_at || t("Not Signed")}
            </p>
          </Col>
          <Col md={3} xs={12} className="mb-1">
            <p>
              <strong>{t("Created By")}:</strong> {data.created_by}
            </p>
          </Col>
          <Col md={3} xs={12} className="mb-1">
            <p>
              <strong>{t("Created At")}:</strong> {data.created_at}
            </p>
          </Col>
          <Col md={3} xs={12} className="mb-1">
            {!!data.reject_reason && (
              <p>
                <strong>{t("Reject Reason")}:</strong>{" "}
                {data.reject_reason || t("None")}
              </p>
            )}
          </Col>
        </Row>
        {data.status === 1 && (
          <Row className="mb-3 justify-content-end mt-5">
            <Col xs="auto">
              <Button color="primary" onClick={onAccept}>
                {t("Accept")}
              </Button>
            </Col>
            <Col xs="auto">
              <Button color="danger" onClick={onReject}>
                {t("Reject")}
              </Button>
            </Col>
          </Row>
        )}
      </CardBody>
    </Card>
  )
}

export default ContractDetails
